import { featuresItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-star-line"></i>
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">平台优势</h2>
          <p className="text-foreground-600 text-sm">四大核心优势，重新定义吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 border border-secondary-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}